import { render, staticRenderFns } from "./SciApplications.vue?vue&type=template&id=37121251"
import script from "./SciApplications.vue?vue&type=script&lang=js"
export * from "./SciApplications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports